export default "__VITE_ASSET__jsRYh6x$__"